export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'invoiceNo',
    label: 'field.invoiceNo',
    // stickyColumn: true,
    // variant: 'light',
    tdClass: 'limit-size',
  },
  {
    key: 'name',
    label: 'field.name',
  },
  {
    key: 'userName',
    label: 'field.username',
  },
  {
    key: 'agentName',
    label: 'field.agentName',
  },
  {
    key: 'agentUserName',
    label: 'field.agentUsername',
  },
  {
    key: 'amount',
    label: 'field.amount',
  },
  {
    key: 'type',
    label: 'field.prize',
  },
  {
    key: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
]
